var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGazaRamadanOffersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.325 15.42c0 6.667-4.982 12.169-11.33 12.737C7.649 27.59 2.667 22.101 2.667 15.42c0-6.682 5.01-12.212 11.385-12.752 6.32.611 11.274 6.084 11.274 12.752z",
    fill: "url(#kae5d0i5ka)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.667 15.412c0 7.038 6.995 12.745 15.622 12.745.469 0 .92 0 1.371-.056-7.985-.567-14.25-6.047-14.25-12.689S11.674 3.29 19.66 2.723a14.552 14.552 0 0 0-1.37-.056c-8.628 0-15.623 5.707-15.623 12.745z",
    fill: "url(#shsitxhg9b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.412 28.157c7.039 0 12.745-5.706 12.745-12.745 0-7.039-5.706-12.745-12.745-12.745-7.04 0-12.746 5.706-12.746 12.745 0 7.04 5.707 12.745 12.746 12.745z",
    stroke: "url(#vh1kpfbexc)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.865 9.73c0-.437-.35-.79-.783-.79a.787.787 0 0 0-.784.79v.89c-1.678.232-2.81 1.309-2.81 2.828v.03c0 1.728 1.08 2.314 2.81 2.777v2.117a4.962 4.962 0 0 1-1.467-.711 1.01 1.01 0 0 0-.631-.2c-.583 0-1.036.43-1.036.969 0 .323.178.615.42.784l-.032.016a6.734 6.734 0 0 0 2.746 1.06v.92c0 .436.351.79.784.79a.787.787 0 0 0 .783-.79v-.866c1.864-.165 3.135-1.2 3.135-2.93v-.03c0-1.65-1.119-2.344-3.135-2.85v-1.98c.39.11.786.286 1.192.509.178.092.356.154.567.154.583 0 1.036-.43 1.036-.969 0-.4-.243-.692-.486-.83a5.643 5.643 0 0 0-2.309-.794v-.895zm-1.567 2.78c-.42.138-.641.415-.641.738v.03c0 .374.154.597.641.803v-1.57zm1.567 4.177v1.8c.615-.101.965-.409.965-.857v-.03c0-.387-.186-.64-.965-.913z",
    fill: "#00A6CE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "kae5d0i5ka",
    x1: 2.667,
    y1: 17.49,
    x2: 25.614,
    y2: 10.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shsitxhg9b",
    x1: 2.667,
    y1: 17.49,
    x2: 20.483,
    y2: 13.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vh1kpfbexc",
    x1: 2.667,
    y1: 17.49,
    x2: 27.961,
    y2: 9.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGazaRamadanOffersIcon);
export default __webpack_public_path__ + "static/media/gazaRamadanOffersIcon.88ee813bbb3b9d8131c1d404f5eba8f8.svg";
export { ForwardRef as ReactComponent };